export const WorkOrderLabel = {
  WorkOrderTitle: "Work Order",
  WorkOrder: "Work Order",
  NewWorkOrder: "New Work Order",
  EditWorkOrder: "Edit Work Order",
  ViewWorkOrder: "View Work Order",
  VendorName: "Customer Name",
  VendorId: "Customer ID",
  QuoteNo: "Quote No",
  GST: "GST",
  GstAmount:"Gst Amount",
  QuoteAmt: "Quote Amount (Incl Of Tax)",
  QuoteAmtInc: "Quote Amount (Incl Of Tax)",
  QuoteAmtExl: "Quote Amount (Exl Of Tax)",
  WorkOrderNo: "W.O No",
  WorkOrderAmt: "W.O Amt (Incl Of Tax)",
  WorkOrderAmtInc: "W.O Amount (Incl Of Tax)",
  WorkOrderAmtExl: "W.O Amount (Exl Of Tax)",
  WorkOrderDate: "W.O Date",
  Difference: "Difference",
  DifferenceDes: "Difference (W.O AMT(EXl OF TAX)- QUOTE Amount(Exl of Tax))",
  QuotationDate: "Quotation Date",
  Warranty: "Warranty",
  Remarks: "Remarks",
  Discount:"Discount",
  QuotationPdf: "Quotation PDF",
  Download: "Download",
  Publish: "Publish",
  Pending: "Pending",
  Status:"Status",
  View: "View",
  TaxInvoice: "Tax Invoice",
  Generated: "Generated",
  NotGenerated: "Not Generated",
  IsGenerated: "Is Generated",
  Product: "Product",
  SrNo: "Sr No.",
  ProductName: "Product Name",
  DescriptionOfGoods: "Description of Goods",
  DescriptionSubHead: "Description Sub Head",
  HSN_SAC: "HSN/SAC",
  Quantity: "Quantity",
  Rate: "Rate",
  Per: "UOM",
  TotalAmount: "Total Amount",
  Amount:"Amount",
};
export const ConditionOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
];
export const WorkOrderKey = {
  VendorName: "customer_name",
  VendorID: "customer_id",
  QuoteNo: "quotation_id",
  QuoteAmt: "quotation_incl_tax_amount",
  WorkOrderNo: "work_order_number",
  WorkOrderAmt: "work_order_incl_tax_amount",
  WorkOrderDate: "work_order_date",
  QuotationDate: "quotation_date",
  TaxInvoice: "is_tax_invoice_generated",
  Warranty: "warranty",
  SrNo: "sr_no",
  ProductName: "product_name",
  DescriptionOfGoods: "description",
  DescriptionSubHead: "sub_description",
  HSN_SAC: "hsn_sac_code",
  Quantity: "quantity",
  Rate: "rate",
  Per: "uom",
  Amount: "with_gst_amount",
  QuotationGst: "gst",
  GstAmount: "gst_amount",
};
